import { useCallback, useEffect } from 'react';
import ListViewHOC from 'components/ListView';
import DefaultListView from 'components/ListView/DefaultListView';
import {
  createUnsaveDashboard,
  deleteHubDashboard,
  deleteUnsaveDashboard,
  fetchHubDashboard,
  hubDashboardSelector,
  selectedHubDashboardSelector,
  setSelectedDashboard,
} from 'slices/hubDashboard.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';

const DashboardSelection = () => {
  const dispatch = useAppDispatch();
  const dashboards = useAppSelector(hubDashboardSelector);
  const selectedDashboard = useAppSelector(selectedHubDashboardSelector);

  useEffect(() => {
    dispatch(fetchHubDashboard());
  }, []);

  const handleDashboardSelect = useCallback(
    (dashboardId: string) => {
      dispatch(setSelectedDashboard(dashboardId));
    },
    [dispatch]
  );

  const onDeleteDashboard = useCallback(
    (dashboardId: string) => {
      if (dashboardId === 'new') {
        dispatch(deleteUnsaveDashboard());
      } else {
        dispatch(deleteHubDashboard(dashboardId));
      }
    },
    [dispatch, selectedDashboard]
  );

  const handleCreateUnsaveDashboard = useCallback(() => {
    dispatch(createUnsaveDashboard());
  }, [dispatch]);

  return (
    <ListViewHOC
      sectionHeading="Dashboard"
      number={dashboards.length}
      onSelect={handleCreateUnsaveDashboard}
    >
      <DefaultListView
        data={(dashboards || []).map((dashboard) => ({
          listLabel: dashboard.name === '' ? '(New Dashboard)' : dashboard.name,
          value: dashboard.id,
        }))}
        onSelect={handleDashboardSelect}
        onDelete={onDeleteDashboard}
        selectedItemId={selectedDashboard?.id}
      />
    </ListViewHOC>
  );
};

export default DashboardSelection;
